export interface ILazyScriptsService {
	runLazyScripts: () => void
}
interface IScriptCustomParams {
	[key: string]: string
}

interface IScript {
	url?: string
	async?: boolean
	defer?: boolean
	children?: string
	customParams?: IScriptCustomParams
	productionOnly?: boolean
}

const loadScript = (script: IScript) => {
	console.log('script', script)
	return new Promise<void>((resolve) => {
		const scriptElement = document.createElement('script')
		scriptElement.addEventListener('load', () => {
			resolve()
		})
		const config = useRuntimeConfig()
		const isProduction = config.public.environment === 'production'

		const isScriptAlreadyLoaded = document.querySelector(`script[src="${script.url}"]`)

		if (isScriptAlreadyLoaded) {
			resolve()
			return
		}

		if (script.productionOnly && !isProduction) {
			resolve()
			return
		}

		if (script.url) {
			scriptElement.src = script.url
		}

		if (script.async) {
			scriptElement.async = script.async
		}

		if (script.defer) {
			scriptElement.defer = script.defer
		}

		if (script.children) {
			scriptElement.innerHTML = script.children
		}

		if (script.customParams) {
			Object.entries(script.customParams).forEach(([key, value]) => {
				scriptElement.setAttribute(key, value)
			})
		}
		document.head.appendChild(scriptElement)
	})
}

const scripts: IScript[] = [
	{
		async: true,
		productionOnly: true,
		url: 'https://web.cmp.usercentrics.eu/ui/loader.js',
		customParams: {
			type: 'text/partytown',
			id: 'usercentrics-cmp',
			'data-settings-id': 'XQqurRXXXXmq6t',
		},
	},
	{
		productionOnly: false,
		url: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBno6WmpUhO65C5y8JFddiewTnKTK29h94&loading=async&libraries=places',
	},
	{
		productionOnly: false,
		async: true,
		url: 'https://unpkg.com/leaflet.fullscreen@1.6.0/Control.FullScreen.js',
	},
]

export const useLazyScriptsService = () => {
	const runLazyScripts = async () => {
		await Promise.all(scripts.map((script) => loadScript(script)))
	}

	return {
		runLazyScripts,
	}
}
